export default "__VITE_ASSET__d0c0b179__"